module.exports = __webpack_public_path__ + "static/media/bg.fc2936c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg.jpg
// module id = 416
// module chunks = 0